import { render, staticRenderFns } from "./SvgPictoLuck.vue?vue&type=template&id=2d1c2146&scoped=true"
import script from "./SvgPictoLuck.vue?vue&type=script&lang=ts"
export * from "./SvgPictoLuck.vue?vue&type=script&lang=ts"
import style0 from "./SvgPictoLuck.vue?vue&type=style&index=0&id=2d1c2146&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d1c2146",
  null
  
)

export default component.exports